import type { FigmaIconProps } from './types';

export const IconFigmaSearch = ({ size = 16, color = 'currentColor' }: FigmaIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.8943 8.45157C12.8943 6.27407 11.1291 4.50886 8.95157 4.50886C6.77407 4.50886 5.00886 6.27407 5.00886 8.45157C5.00886 10.6291 6.77407 12.3943 8.95157 12.3943V13.7365C6.0328 13.7365 3.66667 11.3703 3.66667 8.45157C3.66667 5.5328 6.0328 3.16667 8.95157 3.16667C11.8703 3.16667 14.2365 5.5328 14.2365 8.45157C14.2365 11.3703 11.8703 13.7365 8.95157 13.7365V12.3943C11.1291 12.3943 12.8943 10.6291 12.8943 8.45157Z"
      fill={color}
    />
    <path
      d="M12.2688 11.7688C12.5309 11.5067 12.9557 11.5067 13.2178 11.7688L16.1368 14.6878C16.3989 14.9499 16.3989 15.3747 16.1368 15.6368C15.8747 15.8989 15.4499 15.8989 15.1878 15.6368L12.2688 12.7178C12.0067 12.4557 12.0067 12.0309 12.2688 11.7688Z"
      fill={color}
    />
  </svg>
);
